/* eslint-disable react/no-array-index-key */
import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { BodyCell, CellDescription, BodyItem } from './BodyCell';

export interface TableBodyProps {
  body: BodyItem[];
  itemMap: CellDescription[];
}

const TableBody: React.FC<TableBodyProps> = ({ body = [], itemMap = [] }) => (
  <tbody className="ui-table-body">
    {body.map((item: BodyItem, rowIndex: number) => (
      <tr key={`id-table-body-${rowIndex}`} className="ui-table-body-row">
        {itemMap.map((mapItem, cellIndex: number) => {
          if (mapItem.isColumnHidden) {
            return null;
          }

          return (
            <BodyCell
              key={`id-table-body-row-${rowIndex}-cell-${cellIndex}`}
              rowIndex={rowIndex}
              item={item}
              {...mapItem}
            />
          );
        })}
      </tr>
    ))}
  </tbody>
);

export default TableBody;
